import PropTypes from 'prop-types';
import AnnotationShape from '../AnnotationShape';

export default PropTypes.shape({
    id: PropTypes.string,
    collaboratorId: PropTypes.string,
    body: PropTypes.string,
    createdAt: PropTypes.number,
    timecode: PropTypes.number,
    annotation: AnnotationShape,
    pending: PropTypes.bool,
    parentId: PropTypes.string,
    fileId: PropTypes.string,
    groupId: PropTypes.string,
    reviewId: PropTypes.string
});
